import { colors } from "../../Styles";

export function ArrowReset({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height="100%" viewBox="0 0 284 284" version="1.1" fill={fillColor} style={{strokeLinecap: "round"}}>
      <path d="M27.873,27.418L25.975,122.714L117.991,97.853L27.873,27.418Z"/>
      <path d="M63.54,74.651C63.54,74.651 90.786,39.791 139.292,39.571C186.89,39.356 242.327,75.166 243.042,138.354C243.833,208.284 187.33,243.423 138.068,244.006C92.193,244.549 61,205.051 61,205.051" style={{fill: "none", stroke: fillColor, strokeWidth: "30px"}}/>
    </svg>
  );
}
